import { Element, InstallSpec, ItemComponent } from "../../../install/types.ts";

const bastionOptions = {
  single: {
    label: "Single bastion host",
    description:
      "A single Azure Bastion host for subscription that users connect to the vms.",
    schema: {
      bastionId: Element({
        type: "string",
        label: "Bastion host ID",
        description: "The Azure Bastion host ID.",
      }),
    },
  },
  subscription: {
    label: "Subscription bastion host",
    description: "Azure Bastion hosts configured for different subscriptions.",
    schema: {
      subscriptionId: Element({
        type: "dynamic",
        label: "Subscription ID",
        description:
          "The subscription ID for existing Azure Bastion host configuration.",
      }),
    },
  },
};

export const AzureComponents = InstallSpec({
  root: ItemComponent({
    label: "Microsoft Azure",
    description: "Microsoft Azure",
    type: "singleton",
    maturity: "ga",
    schema: {
      directoryId: Element({
        type: "string",
        label: "Tenant ID",
      }),
      serviceAccountEmail: Element({
        label: "P0 service account human-readable identifier",
        type: "hidden",
      }),
      serviceAccountId: Element({
        label: "P0 service account machine identifier",
        type: "hidden",
      }),
    },
  }),
  "azure-app": ItemComponent({
    label: "Azure app registration",
    description:
      "Allows P0 to authenticate and authorize with Microsoft Azure to provision access.",
    type: "singleton",
    maturity: "ga",
    schema: {
      clientId: Element({
        type: "string",
        label: "Application ID",
        description: "The application (client) ID of the app registration.",
      }),
      clientServicePrincipalId: Element({
        type: "hidden",
        label: "Service principal ID",
      }),
    },
  }),
  "iam-write": ItemComponent({
    label: "IAM management",
    description:
      "Allows P0 to grant and revoke resource access using Azure role-based access control (RBAC).",
    type: "string",
    maturity: "ga",
    schema: {
      resourceId: Element({
        type: "hidden",
        label: "Subscription resource ID",
      }),
    },
  }),
  "iam-assessment": ItemComponent({
    label: "IAM assessment",
    description:
      "Allows P0 to assess and analyze Azure role assignments, permissions, and resource access for security compliance.",
    type: "string",
    maturity: "beta",
    schema: {
      resourceId: Element({
        type: "hidden",
        label: "Subscription resource ID",
      }),
    },
  }),
  "bastion-host": ItemComponent({
    label: "Bastion host",
    description:
      "Allows P0 to grant access to Azure VMs using a secure bastion host.",
    type: "dynamic",
    maturity: "beta",
    schema: {
      bastion: Element({
        label:
          "Which Azure Bastion host should P0 use to provision SSH access?",
        type: "select" as const,
        default: "single",
        options: bastionOptions,
      }),
      roleDefinitionId: Element({
        type: "string",
        label: "Role Definition ID",
        description: "The Azure Role Definition ID.",
      }),
    },
  }),
});
